import "./App.css";
import Platfrom from "./component/platform";

function App() {
  return (
    <div className="bg">
      <Platfrom />
    </div>
  );
}

export default App;
